export const PriceTypes = Object.freeze({
  FIXED: 'FIXED',
  VARIABLE: 'VARIABLE',
  REDEEMABLE: 'REDEEMABLE',
});
